import { createFileRoute } from "@tanstack/react-router"
import { SpinsPanel } from "@/features/live-events-admin/spins/SpinsPanel"

export const Route = createFileRoute("/live-events/$eventId/spins")({
	component: SpinsPage,
})

function SpinsPage() {
	const { eventId } = Route.useParams()
	return <SpinsPanel eventId={eventId} />
}
